export const TaskTypeEnum = {
  PhotoIDUpload: "ID_DOCUMENT_UPLOAD",
  UpdatedChildConsent: "UPDATED_CHILD_CONSENT",
  UpdatedConsentRequired: "UPDATED_CONSENT_REQUIRED",
  UpdatedPolicies: "UPDATED_POLICIES",
} as const;
